/** Admin / partner-admin chrome always uses TagadaPay platform branding. */
export const isPlatformAdminRoute = (pathname: string): boolean =>
  pathname.startsWith('/admin') || pathname.startsWith('/partner-admin');
